import React, { useEffect } from "react"

import { getViewport } from "utils"

import Batch from "./batch"
import { ViewMoreButton } from "./styles"

const ArticleBatchScrollLoader = ({
  id,
  batches,
  chunksPerBatch,
  chunkLength,
  gridComponent,
  hasMore,
  pageType,
  onViewMoreClick,
}) => {
  useEffect(() => {
    if (batches.length > 1 && batches[batches.length - 1].length > 0) {
      if (getViewport() !== "mobile") {
        const batchArticles = document.querySelector(
          `#${id}-batch-${batches[batches.length - 1][0].id}`,
        )
        const firstChunk = batchArticles.firstChild
        const firstArticle = firstChunk.firstChild.firstChild.children[1].firstChild
        const titleLink = firstArticle.children[1].children[1]
        titleLink.focus()
      }
    }
  }, [id, batches])

  return (
    <>
      {batches.map((batch, i) => (
        <Batch
          key={`${id}-batch-${batch[0]?.id}`}
          id={`${id}-batch-${batch[0]?.id}`}
          batch={batch}
          batchIndex={i}
          chunksPerBatch={chunksPerBatch}
          chunkLength={chunkLength}
          gridComponent={gridComponent}
          pageType={pageType}
        />
      ))}
      {hasMore && <ViewMoreButton onClick={onViewMoreClick}>view more articles</ViewMoreButton>}
    </>
  )
}

export default ArticleBatchScrollLoader
